import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { Subject } from 'rxjs';
import { DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss']
})
export class DocumentationComponent implements OnInit {

  doc: any[] = [];
  optionsdt: DataTables.Settings = {};
  triggerdt: Subject<any> = new Subject();
  pdf = '';

  constructor(
    private rest: RestService,
    private dom: DomSanitizer
  ) {
    this.GetDocumentation();
  }

  ngOnInit() {
    this.optionsdt = {
      pagingType: 'full_numbers',
      pageLength: 3,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_',
        info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }
      },
      responsive: true,
      scrollX: true,
      autoWidth: false
    };
  }

  ngOnDestroy() { if (!!this.triggerdt) this.triggerdt.unsubscribe(); }

  GetDocumentation() {
    this.rest.GetDocumentation().subscribe( (data) => {
      this.doc = data['data'];
      this.triggerdt.next();
    });
  }

  LoadPdf(item) {
    this.pdf = item.archivo;
  }

}
